<template>
  <div id="dragIndex" :style="drawStyle">
  </div>
</template>

<script>
export default {
  name: 'drag-index',

  data () {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      drawing: false,
      currentMatches: []
    }
  },

  mounted () {
    this.$bus.on('confirmTabOrderUpdate', this.confirmIndexUpdate)
    this.$bus.on('cancelTabOrderUpdate', this.cancelIndexUpdate)
    document.onmousedown = this.mouseDown // TODO: Move this to draw mode toggle
  },

  computed: {
    drawStyle () {
      if (!this.drawing) return 'top:' + (this.y - 55) + 'px;left:' + this.x + 'px;'
      else return 'display:block;top:' + (this.y - 55) + 'px;left:' + this.x + 'px;width:' + this.width + 'px;height:' + this.height + 'px;'
    }
  },

  methods: {
    confirmIndexUpdate () {
      for (let i = 0; i < this.currentMatches.length; i++) {
        const topIndex = this.$store.getters.topTabOrder()
        const element = this.currentMatches[i]
        this.$store.commit('setTabOrder', {id: element.fieldName, index: topIndex + 1})
        this.$bus.emit('setTabOrder', {id: element.fieldName, index: topIndex + 1})
      }
      const prevValue = this.$store.state.assigningIndexes
      this.$store.commit('setAssigningIndexes', !prevValue)
      this.$store.commit('setAssigningIndexes', prevValue)
      this.$store.dispatch('saveTemplate')
      this.currentMatches = []
    },

    cancelIndexUpdate () {
      this.currentMatches = []
    },

    mouseCoords (e) {
      let posx = -1
      let posy = -1
      if (e.pageX || e.pageY) {
        posx = e.clientX
        posy = e.clientY
      }
      return {x: posx, y: posy}
    },

    mouseDown (ev) {
      if (this.drawing || !this.$store.state.dragIndex) return // TODO: Draw mode
      let coords = this.mouseCoords(ev)
      this.x = coords.x
      this.y = coords.y
      this.width = 0
      this.height = 0
      this.drawing = true
      document.onmousemove = this.mouseUpdate
      document.onmouseup = this.mouseUp
    },

    mouseUpdate (ev) {
      let coords = this.mouseCoords(ev)
      if (this.drawing) {
        this.width = coords.x - this.x
        this.height = coords.y - this.y
      } else {
        this.x = coords.x
        this.y = coords.y
      }
    },

    mouseUp (ev) {
      this.drawing = false
      document.onmouseup = null
      document.onmousemove = null
      this.calculateFields()
    },

    compare (a, b) {
      if (a.y1 < b.y1) return -1
      if (a.y1 > b.y1) return 1
      if (a.y1 === b.y1 && a.x1 < b.x1) return -1
      if (a.y1 === b.y1 && a.x1 > b.x1) return 1
      return 0
    },

    calculateFields () {
      const pos = {
        x: this.x,
        y: this.y
      }
      const region = {
        x1: pos.x,
        y1: pos.y,
        x2: pos.x + this.width,
        y2: pos.y + this.height
      }
      this.currentMatches = []

      this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][this.$store.state.fileCurrentPage].forEach(element => {
        if (document.getElementById(element.id) !== null) {
          let elRect = document.getElementById(element.id).getBoundingClientRect()

          let elRegion = {
            fieldName: element.id,
            x1: Number(elRect.left + window.scrollX),
            y1: Number(elRect.top + window.scrollY),
            x2: Number(elRect.left + window.scrollX + elRect.width),
            y2: Number(elRect.top + window.scrollY + elRect.height)
          }

          if (elRegion.x1 >= region.x1 && elRegion.x1 <= region.x2 && elRegion.x2 <= region.x2) {
            if (elRegion.y1 >= region.y1 && elRegion.y2 <= region.y2 && elRegion.y2 <= region.y2) {
              this.currentMatches.push(elRegion)
            }
          }
        }
      })
      if (!this.currentMatches.length) return
      this.$store.commit('setDragIndex', false)
      this.currentMatches = this.currentMatches.sort(this.compare)
      this.$bus.emit('showDialog', {
        title: 'Assign Tab Indexes?',
        desc: 'You are about to update ' + this.currentMatches.length + ' fields. Do you want to continue?',
        confirmAction: 'confirmTabOrderUpdate',
        cancelAction: 'cancelTabOrderUpdate'
      })
    }
  }

  // beforeDestroy () {
  //   this.$bus.$off('confirmTabOrderUpdate')
  //   this.$bus.$off('cancelTabOrderUpdate')
  // }
}
</script>

<style lang="scss" scoped>
  #dragIndex {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    display: none;
    z-index: 10;
    border: 1px dashed black;
    background-color: rgba(57, 119, 26, 0.4);
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/main/DragIndex.vue